var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResult = function SvgNoResult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.303 30.276c1.525.628 3.195.974 4.947.974 7.18 0 13-5.82 13-13 0-1.752-.347-3.424-.975-4.95M9.048 27.434A12.96 12.96 0 0 1 5.25 18.25c0-7.18 5.82-13 13-13 3.543 0 6.755 1.418 9.1 3.716"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m27.442 27.442 3.54 3.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M34.518 30.982a2.5 2.5 0 1 0-3.536 3.536l8 8a2.5 2.5 0 1 0 3.536-3.536zM6.25 30.25l24-24"
  })));
};
export default SvgNoResult;